import { render, staticRenderFns } from "./ReferralDutyConsultationImport.vue?vue&type=template&id=4eb3f76a&scoped=true"
import script from "./ReferralDutyConsultationImport.vue?vue&type=script&lang=js"
export * from "./ReferralDutyConsultationImport.vue?vue&type=script&lang=js"
import style0 from "./ReferralDutyConsultationImport.vue?vue&type=style&index=0&id=4eb3f76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3f76a",
  null
  
)

export default component.exports